export const canShareRow = (row, type = "category") =>
  type !== "section" &&
  row.blocks.length < 4 &&
  !row.blocks.some((block) => block.type === "section");

// Destinations use stable row IDs so a pending category save keeps its place
// even if another layout operation changes row indices.
export function insertBlock(rows, block, destination, rowUuid) {
  const [position, targetUuid] = destination.split(":");
  const targetIndex = rows.findIndex((row) => row.uuid === targetUuid);
  if (
    position === "row" &&
    targetIndex >= 0 &&
    canShareRow(rows[targetIndex], block.type)
  ) {
    return rows.map((row, index) =>
      index === targetIndex ? { ...row, blocks: [...row.blocks, block] } : row
    );
  }
  // A full/deleted target or section header still gets a usable placement.
  // Prefer a new row immediately after the target, otherwise the bottom.
  const index =
    targetIndex < 0
      ? rows.length
      : targetIndex + (position === "before" ? 0 : 1);
  const next = [...rows];
  next.splice(index, 0, { uuid: rowUuid, blocks: [block] });
  return next;
}

export function moveRow(rows, rowUuid, offset) {
  const index = rows.findIndex((row) => row.uuid === rowUuid);
  const target = index + offset;
  if (index < 0 || target < 0 || target >= rows.length) return rows;
  const next = [...rows];
  [next[index], next[target]] = [next[target], next[index]];
  return next;
}

export function moveBlockWithinRow(rows, rowUuid, blockUuid, offset) {
  const row = rows.find((item) => item.uuid === rowUuid);
  const index =
    row?.blocks.findIndex((block) => block.uuid === blockUuid) ?? -1;
  const target = index + offset;
  if (!row || index < 0 || target < 0 || target >= row.blocks.length)
    return rows;
  const blocks = [...row.blocks];
  [blocks[index], blocks[target]] = [blocks[target], blocks[index]];
  return rows.map((item) => (item === row ? { ...item, blocks } : item));
}

export function moveBlockToNewRow(
  rows,
  rowUuid,
  blockUuid,
  offset,
  newRowUuid
) {
  const row = rows.find((item) => item.uuid === rowUuid);
  const block = row?.blocks.find((item) => item.uuid === blockUuid);
  if (!block || row.blocks.length < 2) return rows;
  const remaining = rows.map((item) =>
    item === row
      ? {
          ...item,
          blocks: item.blocks.filter((item) => item.uuid !== blockUuid),
        }
      : item
  );
  return insertBlock(
    remaining,
    block,
    `${offset < 0 ? "before" : "after"}:${rowUuid}`,
    newRowUuid
  );
}
